export const arr=[
    {key:"Alphabet_Letters",value:"Barua za Alfabeti"},
    {key:"Birds",value:"Ndege"},
    {key:"Bus_Round_in_the_Town",value:"Basi_Kuzunguka_Mjini"},
    {key:"Colors",value:"Rangi"},
    {key:"Comparison_For_Kids",value:"Kulinganisha Kwa Watoto"},
    {key:"Energy",value:"Nishati"},
    {key:"Exercise_Tips_For_Health",value:"Vidokezo_ vya_Mazoezi_Kwa_Afya"},
    {key:"For_The_Birds",value:"Kwa_Ndege"},
    {key:"Johny_Johny_Yes_Papa_Poem",value:"Johny_Johny_Yes_Papa_Poem"},
    {key:"kindness",value:"wema"},
    {key:"Lambs",value:"Wana-kondoo"},
    {key:"Lambs_Fights",value:"Mapambano_ya_Kondoo"},
    {key:"Long_And_Short",value:"Mrefu_Na_Mfupi"},
    {key:"Nature_Walks",value:"Maumbile_Matembezi"},
    {key:"Periodic_Table",value:"Jedwali_la_Kipindi"},
    {key:"Princess_Birthday",value:"Siku ya_ya_Kuzaliwa"},
    {key:"Pussy_Cat",value:"Pussy_Cat"},
    {key:"Road_Safety",value:"Usalama barabarani"},
    {key:"Sisters_Love",value:"Wadada_Mapenzi"}

  ]